import { Action, createReducer, on } from '@ngrx/store';
import * as FMFActions from '@store/actions/fraud-micro-frontend/fmf.action';

export interface IFMFState {
  transactionId: string;
}

export const INITIAL_STATE: IFMFState = {
  transactionId: '',
};

const FMFReducer = createReducer(
  INITIAL_STATE,
  on(FMFActions.SetFMFTId, (state, { payload: { transactionId } }) => ({
    ...state,
    transactionId,
  })),
);

export function reducer(state: IFMFState | undefined, action: Action) {
  return FMFReducer(state, action);
}
